/* File: src/components/explanations/shredsListExplanation.ts */
export const shredsListExplanation = `
<div class="text-gray-300 text-lg mb-4">

    <hr class="border-b-1 border-gray-600 my-2">
  
    <h2 class="text-blue-400 text-xl font-bold mb-2">1. What is This ?</h2>
    <p class="text-gray-200 text-base mb-4">
      Bellow a prompt generated by ShredsAI describing this Shred based on the architecture and the technical specifications.
    </p>
    <h2 class="text-green-400 text-xl font-bold mb-2">2. Can i modify it ?</h2>
    <p class="text-gray-200 text-base mb-4">
      Yes, ShredsAI made its best guess, but we encourage you to modify it to better fit your needs.
    </p>
    <h2 class="text-red-400 text-xl font-bold mb-2">3. What information should i include ?</h2>
    <p class="text-gray-200 text-base">
      Include all details you can think of : business rules, technical specifications, libraries you prefer, etc.
      <span class="chip">TIP</span> : You dont need to include all the details, you will still be able to modify the final description in next step.
    </p>
  
</div>
`;